import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IconComponent, IconButtonComponent, trackByFactory } from '@mode/capra';
import { FileExportDomain } from '@mode/shared/contract-common';
import { FileExportsUiListItemComponent } from '../file-exports-ui-list-item/file-exports-ui-list-item.component';

/**
 * Placeholder component, delete or remake if needed
 */
@Component({
  selector: 'mode-file-exports-ui-drawer',
  standalone: true,
  imports: [CommonModule, IconComponent, IconButtonComponent, FileExportsUiListItemComponent],
  templateUrl: './file-exports-ui-drawer.component.html',
  styleUrls: ['./file-exports-ui-drawer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FileExportsUiDrawerComponent {
  @Input() downloads: FileExportDomain.FileExport[] | undefined;
  @Input() expanded: boolean | undefined;
  @Input() visible: boolean | undefined;
  @Input() drawerContext: 'embed' | 'report' | 'editor' | undefined; // For possible future use

  @Output() expandDrawer = new EventEmitter<void>();
  @Output() closeDrawer = new EventEmitter<void>();
  @Output() downloadCsv = new EventEmitter<string>();
  @Output() retryDownloadCsv = new EventEmitter<string>();
  @Output() deleteCsv = new EventEmitter<string>();

  trackByFn = trackByFactory<FileExportDomain.FileExport>(({ id }) => id);

  onExpandDrawerClick() {
    this.expandDrawer.emit();
  }

  onCloseDrawerClick() {
    this.closeDrawer.emit();
  }

  hasDownloads() {
    return this.downloads !== undefined && this.downloads.length > 0;
  }

  shouldShowDrawer() {
    return this.visible === true && this.hasDownloads();
  }

  shouldBeExpanded() {
    return this.expanded === true && this.hasDownloads();
  }

  onDownloadCsv(id: string) {
    this.downloadCsv.emit(id);
  }

  onRetryDownloadCsv(id: string) {
    this.retryDownloadCsv.emit(id);
  }

  onDeleteDownloadCsv(id: string) {
    this.deleteCsv.emit(id);
  }
}
